import React, { Component, Fragment } from 'react';
import _ from 'lodash';

import { observer } from 'mobx-react';

import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react';

import { localizable } from 'components/Localization';

import './AuctionFinalsList.css';

// props.store = AuctionFinalsStore
// props.showResults = true | false
// props.showTotals = true | false

@localizable
@observer
export default class AuctionFinalsList extends Component {
  handleRemove = (objectId) => () => {
    const { store } = this.props;
    delete store.selection[objectId];
    this.selectionChanged();
  };

  selectionChanged = () => {
    const { store } = this.props;
    store.selectionChanged();
  };

  render() {
    const { store, showResults, showTotals, locale, currency, t, style } =
      this.props;

    return (
      <Fragment>
        <table className="auction-finals-list" style={style}>
          <thead>
            <tr>
              <th>{t('Object no.')}</th>
              <th>{t('Title')}</th>
              <th>{t('Selected buyer')}</th>
              <th>{t('Purchase price')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {store.objects.map((object) => {
              const buyerId = store.selection[object.id];
              if (buyerId) {
                const buyer = _.find(
                  store.buyers,
                  (buyer) => buyer.id === buyerId
                );
                if (buyer) {
                  const offer = _.find(
                    buyer.offers,
                    (offer) => offer.id === object.id
                  );
                  if (offer) {
                    const succeeded = showResults
                      ? _.find(store.results.succeeded, {
                          saleId: object.id,
                          buyerId: buyer.id,
                        })
                      : null;
                    const failed = showResults
                      ? _.find(store.results.failed, {
                          saleId: object.id,
                          buyerId: buyer.id,
                        })
                      : null;
                    return (
                      <tr
                        key={object.id}
                        className={
                          showResults
                            ? !!succeeded
                              ? 'succeeded'
                              : !!failed
                              ? 'failed'
                              : ''
                            : ''
                        }
                      >
                        <td>{object.name}</td>
                        <td>{object.title}</td>
                        <td>{buyer.name}</td>
                        <td>
                          {offer.price.toFormattedMoney(locale, currency)}
                        </td>
                        <td>
                          {showResults && !!succeeded && (
                            <Icon iconName="CheckMark" />
                          )}
                          {showResults && !!failed && (
                            <Icon iconName="Error" title={failed.error} />
                          )}
                          {!showResults && (
                            <IconButton
                              iconProps={{
                                iconName: 'Cancel',
                              }}
                              onClick={this.handleRemove(object.id)}
                            />
                          )}
                        </td>
                      </tr>
                    );
                  }
                }
              }
              return null;
            })}
            {!showResults && store.selected === 0 && (
              <tr>
                <td colSpan="5">
                  {t(
                    'No offer selected for awardwing, go back to the matrix and pick some.'
                  )}
                </td>
              </tr>
            )}
            {showTotals && store.selected > 0 && (
              <tr>
                <td colSpan="3">
                  <strong>{t('Total')}</strong>
                </td>
                <td>
                  <strong>
                    {store.selectedPrice.toFormattedMoney(locale, currency)}
                  </strong>
                </td>
                <td></td>
              </tr>
            )}
          </tbody>
        </table>
        <div style={{ display: 'none' }}>{store.selectedPrice}</div>
        <div style={{ display: 'none' }}>{store.processed}</div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/AuctionFinals/components/AuctionFinalsList.jsx